import { ChooseCellResponseData } from "@lib/titan2-slingo/dist/api/data/ChooseCellResponseData";
import { ExtendedGameUpdateData } from "../../data/ExtendedGameUpdateData";
/**
 * ExtendedChooseCellResponseData.ts
 */
export class ExtendedChooseCellResponseData extends ChooseCellResponseData {
    solidifyGameUpdate() {
        if (this.dataExists(this.data)) {
            this.gameUpdate = new ExtendedGameUpdateData(this.data);
        }
    }
}
//# sourceMappingURL=ExtendedChooseCellResponseData.js.map